module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 47300.043e17ae.png";